
import React, { useState, useEffect, useMemo } from 'react';
import './Bill.css';
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel,
  Textarea,
} from '@chakra-ui/react';
import { Trash2 } from 'lucide-react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import ProgressBar from '../../../utils/progressBar/ProgressBar.js';
import { createBilling } from '../../../redux/api/billingApi/billingApi';
import { addbillingAction } from '../../../redux/reduxSlice/BillingSlice.js';
import { updateBilling } from '../../../redux/api/billingApi/billingApi';
import { updatebillingAction } from '../../../redux/reduxSlice/BillingSlice.js';
import { getInventory } from '../../../redux/reduxApi/inventoryReduxApi.js';
function BillForm(props) {
  const { isUpdateMode, dataToEdit, formData: initialFormData, setIsUpdateMode, billingId, onNewDataAdded } = props;
  const dispatch = useDispatch();
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [deletedItemRows, setDeletedItemRows] = useState([]);
  const [inventoryOptions, setInventoryOptions] = useState([]);
  const inventoryData = useSelector((state) => state?.inventory?.inventory);
  const { closeDrawer } = props;

  const [formData, setFormData] = useState(
    {
      vendorName: "",
      bill: "",
      orderNumber: "",
      ccsBillserialNo: '',
      billDate: "",
      dueDate: "",
      paymentTerms: "",
      notes: "",
      items: [],
    });

  const handleOnClose = () => {
    closeDrawer();
    setIsUpdateMode(false)
    setFormData({
      vendorName: "",
      bill: "",
      orderNumber: "",
      ccsBillserialNo: '',
      billDate: "",
      dueDate: "",
      paymentTerms: "",
      notes: "",
      items: rows || [],
    })
  };


 useEffect(() => {
    dispatch(getInventory(1))
      .catch((error) => {
        console.error('Error fetching Inventory data:', error);
      })
      .finally(() => { });
  }, [dispatch]);

  useEffect(() => {
    // Safely map over inventoryData if it's an array
    const temp = Array.isArray(inventoryData)
      ? inventoryData.map(({ inventory }) => ({
        value: inventory?.ROWID,
        label: inventory?.name,
        ...inventory,
      }))
      : [];
    setInventoryOptions(temp); // Update inventory options
  }, [inventoryData]);

  // Updating row data based on selected item
  const setDataToItemTableRow = (item, index) => {
    if (!item) return;

    setRows((prev) =>
      prev.map((row, idx) =>
        idx === index
          ? {
            ...row,
            inventoryData: item.label || '',
            rowId: item.ROWID || '',
            qty: item.annualQty || 0,
            rate: item.sellingPrice || 0,
            tax: item.tax || 0,
            customerDetails: "",
            annualContractvalue: item.annualContractValue || 0,
            servPClean: item.servPClean || 0,
            annualQty: item.annualQty || 0,
            account: item.account || 0,
          }
          : row
      )
    );
    setFormData((prev) => ({ ...prev, itemtable: [...rows] }));
  };

  const calculateAmount = (qty, rate, discount) => {
    return qty * rate * (1 - discount / 100);
  };

  const calculateTotal = (amount, tax) => {
    return amount * (1 + tax / 100);
  };

  // Delete row function
  const deleteRow = (index) => {
    setRows((prev) => prev.filter((_, idx) => idx !== index));
    setFormData((prev) => ({ ...prev, itemtable: rows.filter((_, idx) => idx !== index) }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData)
    setShowProgressBar(true)
    createBilling(formData)
      .then((response) => {
        onNewDataAdded()
        console.log("Responseeeeeeeeeeeeeeee - ", response);
        if (response.data.success) {
          const ROWID = response.data.ROWID
          dispatch(addbillingAction({ ROWID, formData }));
          console.log(response)
          setFormData()
          setShowProgressBar(false)
          toast.success("Billing added successfully!");
          handleOnClose();
          setFormData();
        }
        else {
          toast.error("Unable to add Billing , Please try again!")
        }
      })
      .catch((error) => {
        console.error("API Error", error);
        setShowProgressBar(false)
        toast.error("Failed to add Billing. Please try again.");
      });
  }


  const handelOnUpdate = (e) => {
    e.preventDefault();
    setShowProgressBar(true);
    updateBilling(formData, billingId).then((response) => {
      console.log({ response })
      toast.success("billing Updated successfully!");
      handleOnClose();
      if (response.data.success) {
        dispatch(updatebillingAction({ formData, billingId }))
        console.log("updated")
      }
    }).catch((error) => {
      setShowProgressBar(false);
      console.log({ error })
    }).finally(() => {
      setShowProgressBar(false);
    })
  };



  // UpdateMode Use-effect
  useEffect(() => {
    console.log({ isUpdateMode }, { dataToEdit })
    if (isUpdateMode && dataToEdit) {
      setFormData((prev) => ({
        ...prev, ...props.dataToEdit,
        itemtable: dataToEdit.items ? [...JSON.parse(dataToEdit.items)] : []
      }
      ))
    }
    console.log(formData)
    if (dataToEdit.items) {
      setRows(JSON.parse(dataToEdit.items))

    }
  }, [isUpdateMode, dataToEdit]);

  const editId = useMemo(() => {
    return props.editId;
  }, [JSON.stringify(props.editId)]);

  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormData(prev => ({ ...prev, [name]: value }))
  };


  useEffect(() => {
    console.log(formData)
  }, [formData])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };




  const customStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused ? 'silver' : 'rgb(93, 135, 255)',
      borderRadius: "20px",
      border: '0.5px solid rgb(196,196,196,0.5) !important'
    }),
  }

  const [rows, setRows] = useState([
    { itemDetail: '', annualQty: '', servPClean: '', rate: "", annualContractvalue: "", tax: '', amount: "", total: '', subTotal: '', account: "", customerDetails: "", discount:"" }
  ]);


  const addRow = (e) => {
    e.preventDefault()
    const newRows = [...rows, { itemDetail: '', annualQty: '', servPClean: '', rate: "", annualContractvalue: "", tax: '', amount: "", total: '', subTotal: '', account: "", customerDetails: "",discount:"" }];
    setRows(newRows);
    setFormData(prev => ({ ...prev, itemtable: newRows }));
  };
 


  const Payment = [
    "Net 7",
    "Net 15",
    "20th following month",
    "Net 30",
    "Net 60",
    "Due End of the month",
    "Due End of next month",
    "Due on receipt",
    "Custom",

  ]


  return (
    <>
      <Drawer
        isOpen={props.isDrawerOpen}
        placement='right'
        size='xl'
        onClose={handleOnClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader> Create Bill</DrawerHeader>
          <DrawerBody>
            {showProgressBar && <ProgressBar colorScheme='pink' />}
            <form onSubmit={isUpdateMode ? handelOnUpdate : handleSubmit}>
              <legend style={{ fontSize: 'Large' }} className='sub-headers'>Description Information</legend>
              <div className='card mt-2'>
                <div className='card-body'>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Vendor Name' name='vendorName' value={formData?.vendorName} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Vendor Name </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Bill' name='bill' value={formData?.bill} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Bill</FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Order Number' name='orderNumber' value={formData?.orderNumber} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Order Number </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Bill No' name='ccsBillserialNo' value={formData?.ccsBillserialNo} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">CCS Bill Serial No </FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='Bill date' name='billDate' value={formData?.billDate} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Bill Date </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='Due date' name='dueDate' value={formData?.dueDate} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3">Due date </FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <select className='form-select input-field' name="paymentTerms" value={formData?.paymentTerms} onChange={handleChange}  >
                    <option value="Due on receipt"></option>
                    {Payment?.map((Payment, index) => (
                      <option key={index} value={Payment}>
                        {Payment}
                      </option>
                    ))}
                  </select>

                  <FormLabel className="small-label ps-3">Payment Terms </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <select className=' rounded' type='text' placeholder="Industry" style={{ width: '100%', backgroundColor: 'white', outline: 'none' }} onChange={handleChange} >
                      <option >At Transaction Level</option>
                      <option >At Line Item Level </option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <select className='rounded' type='text' placeholder="Industry" style={{ width: '100%', backgroundColor: 'white', outline: "none" }}   >
                      <option > Tax Exclusive</option>
                      <option > Tax Inclusive </option>
                    </select>
                  </div>
                </div>

              </div>
              <div className='row mt-3'>
                <div className='col-lg-12'>
                  <Textarea type='text' rows='4' style={{ border: "1px solid grey" }} placeholder='Notes' name='notes' value={formData?.notes} onChange={handleChange} />
                  <FormLabel className="small-label ps-3 "> Notes</FormLabel>

                </div>

              </div>
              </div>
              </div>
              <div className='card mt-2'>
                <div className='card-body'>
              <div className='w-100'>
                <div className='custom-scroll'>
                  <table className='table-class'>
                    <thead>
                      <tr>
                        <th colSpan={12}>
                          <h5 style={{ fontSize: '15px' }}>Item Table</h5>
                        </th>
                      </tr>
                      <tr className='border'>
                        <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>ACTION</th>
                        <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>ITEM DETAILS</th>
                        <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>	ACCOUNT</th>
                        <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>ANNUAL QTY</th>
                        <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>SERVE P / CLEAN</th>
                        <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>ANNUAL CONTRACT VALUE</th>
                        <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>CUSTOMER DETAILS </th>
                        <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>QTY</th>
                        <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>RATE</th>
                        <th className="border" style={{ textAlign: 'center', fontWeight: '500' }}> Discount</th> 
                        <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>TAX</th>
                        <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>AMOUNT</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows?.map((row, index) => (
                        <tr key={index}>
                          <td className='border text-center table-class'>
                            <button onClick={() => deleteRow(index)} className='delete-button'>
                              <Trash2 size={16} color='#dd0b58' />
                            </button>
                          </td>
                          <td className='border table-class'>
                            <div style={{ width:'12rem' }}>
                              <Select
                                name="itemDetails"
                                options={inventoryOptions}
                                value={inventoryOptions.find((option) => option.value === row.rowId) || null}
                                onChange={(option) => setDataToItemTableRow(option, index)}
                                className="custom-select-container"
                                classNamePrefix="custom-select"
                                style={{ width:'100%' }}
                              />
                            </div>
                          </td>
                          <td className='border table-class'>
                            <input
                              className="inputField"
                              type='number'
                              value={row?.account}
                              onChange={(e) => {
                                const newRows = [...rows];
                                newRows[index].account = e.target.value;
                                setRows(newRows);
                                setFormData((prev) => ({ ...prev, itemtable: newRows }));
                              }}
                            />
                          </td>
                          <td className='border table-class'>
                            <input
                              className="inputField"
                              type='number'
                              value={row.annualQty}
                              onChange={(e) => {
                                const newRows = [...rows];
                                newRows[index].annualQty = e.target.value;
                                setRows(newRows);
                                setFormData((prev) => ({ ...prev, itemtable: newRows }));
                              }}
                            />
                          </td>
                          <td className='border table-class'>
                            <input
                              className="inputField"
                              type='text'
                              value={row.servPClean}
                              onChange={(e) => {
                                const newRows = [...rows];
                                newRows[index].servPClean = e.target.value;
                                setRows(newRows);
                                setFormData((prev) => ({ ...prev, itemtable: newRows }));
                              }}
                            />
                          </td>
                          <td className='border table-class'>
                            <input
                              className="inputField"
                              type='number'
                              value={row.annualContractvalue}
                              onChange={(e) => {
                                const newRows = [...rows];
                                newRows[index].annualContractvalue = e.target.value;
                                setRows(newRows);
                                setFormData((prev) => ({ ...prev, itemtable: newRows }));
                              }}
                            />
                          </td>
                          <td className='border table-class'>
                            <input
                              className="inputField"
                              type='text'
                              value={row.customerDetails}
                              onChange={(e) => {
                                const newRows = [...rows];
                                newRows[index].customerDetails = e.target.value;
                                setRows(newRows);
                                setFormData((prev) => ({ ...prev, itemtable: newRows }));
                              }}
                            />
                          </td>
                          <td className="border table-class">
                          <input
                            className="inputField"
                            type="number"
                            value={row.qty}
                            onChange={(e) => {
                              const newRows = [...rows];
                              newRows[index].qty = e.target.value;
                              // Recalculate amount when qty or rate changes
                              newRows[index].amount =
                                newRows[index].qty * newRows[index].rate -
                                (newRows[index].discount * (newRows[index].qty * newRows[index].rate)) / 100;
                              setRows(newRows);
                              setFormData((prev) => ({ ...prev, itemtable: newRows }));
                            }}
                          />
                        </td>
                        <td className="border table-class">
                          <input
                            className="inputField"
                            type="number"
                            value={row.rate}
                            onChange={(e) => {
                              const newRows = [...rows];
                              newRows[index].rate = e.target.value;
                              // Recalculate amount when rate or qty changes
                              newRows[index].amount =
                                newRows[index].qty * newRows[index].rate -
                                (newRows[index].discount * (newRows[index].qty * newRows[index].rate)) / 100;
                              setRows(newRows);
                              setFormData((prev) => ({ ...prev, itemtable: newRows }));
                            }}
                          />
                        </td>
                        <td className="border table-class">
                          <input
                            className="inputField"
                            type="number"
                            value={row.discount}
                            onChange={(e) => {
                              const newRows = [...rows];
                              newRows[index].discount = e.target.value;
                              // Recalculate amount when discount changes
                              newRows[index].amount =
                                newRows[index].qty * newRows[index].rate -
                                (newRows[index].discount * (newRows[index].qty * newRows[index].rate)) / 100;
                              setRows(newRows);
                              setFormData((prev) => ({ ...prev, itemtable: newRows }));
                            }}
                          />
                        </td>
                        <td className="border table-class">
                          <input
                            className="inputField"
                            type="number"
                            value={row.tax}
                            onChange={(e) => {
                              const newRows = [...rows];
                              newRows[index].tax = e.target.value;

                              // Recalculate the amount considering the tax
                              const totalBeforeTax = newRows[index].qty * newRows[index].rate;
                              const discountAmount = (newRows[index].discount / 100 || 0) * totalBeforeTax;
                              const amountBeforeTax = totalBeforeTax - discountAmount;

                              // Calculate tax amount
                              const taxAmount = (amountBeforeTax * newRows[index].tax) / 100;

                              // Final amount including tax
                              newRows[index].amount = amountBeforeTax + taxAmount;

                              setRows(newRows);
                              setFormData((prev) => ({ ...prev, itemtable: newRows }));
                            }}
                          />
                        </td>
                        <td className="border table-class">
                          <input
                            className="inputField"
                            type="number"
                            value={row.amount}
                            readOnly
                          />
                        </td>
                        </tr>
                      ))}
                      <td colSpan={12}>
                        <div className='ps-4' onClick={addRow} style={{ textAlign: 'left' }}>
                          <input type='text' placeholder='+ Add row' style={{ outline: 'none' }} />
                        </div>
                      </td>
                    </tbody>
                  </table>
                </div>
                <div className="row">
                <div className="d-flex justify-content-end align-items-center w-100">
                  <div className="card mt-3" style={{ width: '50%', borderRadius: '6px' }}>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-6"><b>Sub Total</b></div>
                        <div className="col-lg-6 text-end">
                          <p>
                            <b>
                              {rows.reduce((acc, row) => {
                                const total = row.qty * row.rate;
                                const discountAmount = (row.discount / 100) * total;
                                const amountBeforeTax = total - discountAmount;
                                const taxAmount = (amountBeforeTax * row.tax) / 100;
                                return acc + amountBeforeTax + taxAmount;
                              }, 0).toFixed(2)}
                            </b>
                          </p>
                        </div>
                      </div>
                      <div className="row mt-2" style={{ borderTop: '1px solid #e5e5e5' }}>
                        <div className="col-lg-6 mt-2">
                          <p>
                            <b>Total</b>
                          </p>
                        </div>
                        <div className="col-lg-6 text-end mt-2">
                          <b>
                            {rows.reduce((acc, row) => {
                              const total = row.qty * row.rate;
                              const discountAmount = (row.discount / 100) * total;
                              const amountBeforeTax = total - discountAmount;
                              const taxAmount = (amountBeforeTax * row.tax) / 100;
                              return acc + amountBeforeTax + taxAmount;
                            }, 0).toFixed(2)}
                          </b>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              </div>
              </div>
              
            </form>
          </DrawerBody>
          <center><DrawerFooter style={{ display: 'inline-block' }}>
            <div className='gap-3 d-flex'>
              <button variant='outline' className='cancel-button' mr={3} onClick={handleOnClose}>
                Cancel
              </button>
              <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handelOnUpdate(e) }} > {isUpdateMode ? "Update" : "Submit"}</button>
            </div>
          </DrawerFooter></center>
        </DrawerContent>
      </Drawer>
    </>
  )
}
export default BillForm;



















